import { render, staticRenderFns } from "./LabExpense.vue?vue&type=template&id=906ec93e&scoped=true"
import script from "./LabExpense.vue?vue&type=script&lang=js"
export * from "./LabExpense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906ec93e",
  null
  
)

export default component.exports